import { useDCIS } from 'requests/dcis';
import { useClasses } from 'requests/classes';

import Filter from 'components/filtres/Filter';
import { LabelProps } from 'components/filtres/Select/GuideSelect';
import therapeutique from 'assets/svg/therapeutique.svg';
import { useType } from 'requests/medecineTypes';

import { useHistory, useLocation } from 'react-router-dom';
import { encodeUri, decodeUri } from 'utils/url';
import HomeGeneric from '../HomeGeneric/HomeGeneric';

const TypeDevices = () => {
  const location = useLocation();
  const history = useHistory();
  const { data } = useClasses();
  const { data: dataDci } = useDCIS();
  const uri = decodeUri(location.search);

  const { data: dataTypes } = useType({ variables: { id: uri.deviceType }, fetchPolicy: 'no-cache' });

  function handleChoosed(value: LabelProps | null) {
    if (value) {
      if (value.value === 'Tous') {
        const { classe, ...Original } = uri;
        history.replace({
          pathname: location.pathname,
          search: encodeUri({ ...Original }),
        });
      } else {
        history.replace({
          pathname: location.pathname,
          search: encodeUri({ ...uri, classe: value.value }),
        });
      }
    }
  }

  function setDcisChoosed(value: LabelProps | null) {
    if (value) {
      if (value.value === 'Tous') {
        const { dci, ...Original } = uri;
        history.replace({
          pathname: location.pathname,
          search: encodeUri({ ...Original }),
        });
      } else {
        history.replace({
          pathname: location.pathname,
          search: encodeUri({ ...uri, dci: value.value }),
        });
      }
    }
  }
  const textSelected = dataTypes?.type.name;
  return (
    <HomeGeneric
      from="deviceType"
      textSelected={textSelected}
      title="Types de dispositifs"
      filterComponent={
        <>
          <Filter
            isDisabled={Boolean(uri.dci)}
            icon={<img alt="" src={therapeutique} height="23" />}
            title="Classes thérapeutiques"
            type="deviceType"
            type2="classe"
            data={data?.classes.data}
            value={uri.classe}
            onChange={handleChoosed}
          />

          <Filter
            isDisabled={Boolean(uri.classe)}
            className="pt-5"
            icon={<img alt="" src="dcisLogo.svg" height="23" />}
            title="DCI"
            type="deviceType"
            type2="dci"
            data={dataDci?.dcis.data}
            value={uri.dci}
            onChange={setDcisChoosed}
          />
        </>
      }
    />
  );
};

export default TypeDevices;
